let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1pYs7")).then(() => parcelRequire('eDBre'));